module.exports = __webpack_public_path__ + "img/avatar_6@2x.b0843977.png";